export default "__VITE_ASSET__BJSlIBTc__"